const CLIENT_DATA = [
  {
    name: 'Parteek Gupta',
    message: "Tara, your work looks great! It is clear that you care about your work, and I appreciate that you asked the client about their design preferences before creating their website.",
    img: 'https://i.ibb.co/pJvBhQF/1653209666251.jpg',
  },
  {
    name: 'Vijayant Sharma',
    message: "The project met all my requirements completely and the developer was very helpful and polite in nature. Totally satisfied with my website and the project was completed in the time limit also.",
    img: 'https://i.ibb.co/xJpmZm7/sikandar-hayat-aasi-SQd-UONdqx-JI-unsplash.jpg',
  },
  {
    name: 'Arpit Singh',
    message: "Satisfactory work in very short span of time. Professional developer. Liked it. Recommended👍🏻",
    img: 'https://i.ibb.co/9vk9Bsp/1655451816174.jpg',
  },
  {
    name: 'Darshan Patel',
    message: "Exceptional service! I found exactly what I needed on this platform, and the support team was incredibly responsive.",
    img: 'https://i.ibb.co/g7m07Hp/darshan-patel-QJEVpydul-Gs-unsplash.jpg',
  },
];

export default CLIENT_DATA;
